<script setup>
import { UnorderedListOutlined } from '@ant-design/icons-vue';
</script>

<template>
  <Page menu="andamentos">
    <div>
      <a-row
        justify="center"
        style="padding-bottom: 24px"
      >
        <a-col
          :xs="24"
          :md="24"
          :lg="24"
          :xl="24"
        >
          <!-- Page header -->
          <a-row style="margin-bottom: 24px">
            <a-col :span="12">
              <a-breadcrumb>
                <a-breadcrumb-item>
                  <router-link to="/andamentos">
                    Andamentos
                  </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item>Buscar</a-breadcrumb-item>
              </a-breadcrumb>
              <h1>
                <UnorderedListOutlined
                  style="color: #bebcbc; font-size: 18px"
                />
                Buscar andamentos
              </h1>
            </a-col>
            <a-col :span="12">
              <div class="page-header-button-container" />
            </a-col>
          </a-row>
          <!-- /Page header -->
          <AndamentoGqlDatatable />
        </a-col>
      </a-row>
    </div>
  </Page>
</template>
